import { useFxWorkspaceContext } from '@mobile-mapping/providers';
import { t } from '@trimble/i18n';
import { BtnClasses, CustomInput, Popup } from '@tcweb/connect-ui';
import { Component, Show, createSignal } from 'solid-js';
import { Portal } from 'solid-js/web';

export const CreateDraftLayerDialog: Component<{
  show: boolean;
  workspaceId: string;
  onClose(): void;
}> = (props) => {
  return (
    <Show when={props.show}>
      <CreateDraftLayerDialogContent
        workspaceId={props.workspaceId}
        onClose={props.onClose}
      />
    </Show>
  );
};

const CreateDraftLayerDialogContent: Component<{
  workspaceId: string;
  onClose(): void;
}> = (props) => {
  const fxWorkspace = useFxWorkspaceContext();
  const [name, setName] = createSignal('');

  const handleCreate = (): void => {
    const trimmed = name().trim();
    if (trimmed.length === 0) {
      return;
    }

    // TODO(noissue): swap for the async Maps createLayer once available (seam).
    fxWorkspace.createDraftLayer(props.workspaceId, trimmed);
    props.onClose();
  };

  const handleNameKeyDown = (
    event: KeyboardEvent & { currentTarget: HTMLInputElement; target: Element }
  ): void => {
    if (event.key !== 'Enter' || event.isComposing) {
      return;
    }

    event.preventDefault();
    handleCreate();
  };

  return (
    <Portal>
      <Popup
        show={true}
        name="create-draft-layer"
        heading={t('mobileMapping.fxWorkspace.draftLayers.createLayerTitle')}
        role="dialog"
        aria-modal={true}
        overlayClass="z-modal"
        content={
          <CustomInput
            name="draft-layer-name"
            label={t('mobileMapping.fxWorkspace.draftLayers.layerNameLabel')}
            placeholder={t(
              'mobileMapping.fxWorkspace.draftLayers.layerNamePlaceholder'
            )}
            value={name()}
            onInput={(
              event: InputEvent & {
                currentTarget: HTMLInputElement;
              }
            ) => setName(event.currentTarget.value)}
            onKeyDown={handleNameKeyDown}
          />
        }
        primaryBtnLabel={t('mobileMapping.fxWorkspace.draftLayers.createLayer')}
        primaryBtnClass={BtnClasses.PRIMARY}
        primaryBtnDisabled={name().trim().length === 0}
        secondaryBtnLabel={t('general.cancel')}
        secondaryBtnClass={BtnClasses.SECONDARY}
        onPrimaryAction={handleCreate}
        onSecondaryAction={props.onClose}
        onClose={props.onClose}
      />
    </Portal>
  );
};
